import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, NavParams, ToastController, ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { endpoints } from 'src/app/constant/endpoints';
import { AccountService } from 'src/app/provider/account.service';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-edit-address',
    templateUrl: './edit-address.page.html',
    styleUrls: ['./edit-address.page.scss'],
})
export class EditAddressPage implements OnInit {
    settings: any = {}; customer: any;
    addUpdateForm: FormGroup;addid: string;

    governorate: any = [];governorateName:string = null;
    governorateId: number = null;

    areasOrRegion: any = [];
    areasOrRegionId: any = null;

    areaUnitNumber: any = null;
    address: any;optionSheet = [];

    historyRoute = 'address-lists';
    lat: any = "27.2046";
    lon: any = "27.2046";
    constructor(
        private events: Events,
        private formBuilder: FormBuilder,
        private toastCtrl: ToastController,
        private modalCtrl: ModalController,
        private actionSheetCtrl: ActionSheetController,
        private translate: TranslateService,
        private navParams: NavParams,
        private configService: ConfigService,
        private apiService: ApiService,
        private authService: AuthService,
        private accountService: AccountService
    ) {
        this.customer = this.authService.getAuthUser();
        this.addid = this.navParams.get('addid');
        this.apiService
            .get(endpoints.governorates)
            .pipe(first())
            .subscribe((response) => {
                console.log(response);
                if (response.success) {
                    this.governorate = response.data.governorates;
                    console.log(this.governorate);
                    if (this.governorate.length > 0) {
                        this.governorate.forEach(item => {
                            this.optionSheet.push({
                                text: item.title,
                                role: 'selected',
                                data: { region: item.title, id: item.id },
                            });
                        });
                    }
                }
            });
        this.accountService.getIPAddress()
            .then((result: any) => {
                if (result.status === 'success') {
                    this.lat = result.lat;
                    this.lon = result.lon;
                }
            }
        );
        this.addUpdateForm = this.formBuilder.group({
            customer_id: new FormControl(this.customer.id),
            name: new FormControl("", Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(20),
            ])),
            areasOrRegionId: new FormControl("", Validators.compose([
                Validators.required,
            ])),
            block: new FormControl("", Validators.compose([
                Validators.required,
            ])),
            street: new FormControl("", Validators.compose([
                Validators.required,
            ])),
            avenue: new FormControl('', Validators.compose([])),
            floor: new FormControl('', Validators.compose([])),
            house_name: new FormControl('', Validators.compose([])),
            flat: new FormControl('', Validators.compose([])),
            landmark: new FormControl('', Validators.compose([])),
            paci: new FormControl('', Validators.compose([])),
            notes: new FormControl('', Validators.compose([])),
            latitude: new FormControl(this.lat),
            longitude: new FormControl(this.lon),
            is_default: new FormControl(false, Validators.compose([
                Validators.required,
            ])),
        });
    }
    ngOnInit() {
        this.configService.getAppSettings()
            .then((settingData: any) => {
                this.settings = JSON.parse(settingData);
                //console.log(this.settings);
                this.translate.setDefaultLang(this.settings.appLanguage);
                this.translate.use(this.settings.appLanguage);
            }
            );
            this.apiService
            .get(endpoints.addresses + '/' + this.addid + '?customer_id=' + this.customer.id)
            .pipe(first())
            .subscribe((response) => {
                if (response.success) {
                    this.address = response.data.address;
                    console.log(this.address);

                    this.lat = this.address.latitude ? this.address.longitude : this.lat;
                    this.lon = this.address.longitude ? this.address.longitude : this.lon;
                    this.governorateId = this.address.governorate_id;
                    this.areasOrRegionId = this.address.area_id;
                    this.governorateName = this.address.governorate;
                    console.log(this.areasOrRegionId);
                    this.getAreas(this.governorateId);

                    //this.onAreaChange({ 'detail': { 'value': this.address.area_id } });
                    this.addUpdateForm.controls['name'].patchValue(this.address.name);
                    this.addUpdateForm.controls['block'].patchValue(this.address.block);
                    this.addUpdateForm.controls['street'].patchValue(this.address.street);
                    this.addUpdateForm.controls['avenue'].patchValue(this.address.avenue);
                    this.addUpdateForm.controls['floor'].patchValue(this.address.floor);
                    this.addUpdateForm.controls['house_name'].patchValue(this.address.house_name);
                    this.addUpdateForm.controls['flat'].patchValue(this.address.flat);
                    this.addUpdateForm.controls['paci'].patchValue(this.address.paci);
                    this.addUpdateForm.controls['landmark'].patchValue(this.address.landmark);
                    this.addUpdateForm.controls['notes'].patchValue(this.address.notes);
                    this.addUpdateForm.controls['is_default'].patchValue(this.address.is_default);
                } else if (response.code == 401) {
                    this.events.publish('user:login', { user: null, time: new Date() });
                }
            });
    }
    openRegionSheet = async () => {
        const actionSheet = await this.actionSheetCtrl.create({
            header: this.translate.instant('select_your_region'),
            cssClass: 'my-custom-sheet',
            buttons: this.optionSheet,
            backdropDismiss: false,
            keyboardClose: false,
        });
        actionSheet.present();
        await actionSheet.onDidDismiss().then((result) => {
            console.log(result);
            this.getAreas(result.data.id);
            this.governorateId = result.data.id;
            this.governorateName = result.data.region;
            console.log(this.governorateName)
            this.getAreas(this.governorateId);
        });
    }
    getAreas = (governorate_id:number) => {
        this.apiService
        .get(endpoints.areas + '?governorate_id=' + governorate_id)
        .pipe(first())
        .subscribe((response) => {
            console.log(response);
            if (response.success) {
                this.areasOrRegion = response.data.areas;
                console.log(this.areasOrRegion);
                //this.areasOrRegionId = result.data.areas[0].id;
            } else if (response.code == 401) {
                this.events.publish('user:login', { user: null, time: new Date() });
            }
        });
    }
    onSubmitAddress = () => {
        console.log(this.addUpdateForm.value);
        let addUpdateFormValue = this.addUpdateForm.value;
        Object.assign(addUpdateFormValue, {
            "area_id": this.areasOrRegionId ? this.areasOrRegionId : null,
            "governorate_id": this.governorateId
        });

        console.log(addUpdateFormValue);
        delete addUpdateFormValue.areasOrRegionId;
        //return;
        this.apiService
            .put(endpoints.addresses + '/' + this.addid, addUpdateFormValue)
            .pipe(first())
            .subscribe((response) => {
                console.log(response)
                console.log(response.message);
                if (response.success) {
                    this.toastMessage(response.message);
                    this.modalCtrl.dismiss(true, 'close');
                } else if (response.code == 401) {
                    this.events.publish('user:login', { user: null, time: new Date() });
                } else {
                    this.toastMessage(response.message);
                }
            }, (err) => {
                Object.keys(err.error).forEach((key) => {
                    let errorArray = err.error[key];
                    Object.keys(errorArray).forEach((index) => {
                        this.toastMessage(errorArray[index]);
                    });
                });
            });

    }
    toastMessage = async (msg) => {
        await this.toastCtrl.create({
            message: this.translate.instant(msg),
            duration: 4000,
            position: 'top',
            color: 'primary'
        }).then((toastElem) => toastElem.present());
    }
    closeModal = () => {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}